import classes from "./OverviewPage.module.css";
import { IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NotificationIcon from "@mui/icons-material/Notifications";
import HelpIcon from "@mui/icons-material/HelpOutline";
import TableIcon from "../../assets/icon/data-table.png";
import { Button } from "react-bootstrap";

type OverviewPageProps = {
  handleCloseModal: () => void;
};

const OverviewPage: React.FC<OverviewPageProps> = (props) => {
  return (
    <>
      <div className={classes["top-section"]}>
        <div className={classes["title-section"]}>
          <div className={classes["modal-title"]}>Well Test Overview</div>
          <div className={classes["notif-count"]}>27</div>
        </div>
        <div className={classes["tools-section"]}>
          <div className={classes["close-button"]}>
            <Tooltip title="Close">
              <IconButton
                aria-label="Close"
                size="small"
                onClick={props.handleCloseModal}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
          <div className={classes["overview-widget"]}>
            <Tooltip title="Notification">
              <IconButton
                aria-label="Notification"
                size="small"
                onClick={props.handleCloseModal}
              >
                <NotificationIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Help">
              <IconButton
                aria-label="Help"
                size="small"
                onClick={props.handleCloseModal}
              >
                <HelpIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </div>
      <div className={classes["middle-section"]}>
        <div className={classes["middle-top-button"]}>
          <div className={classes["left-side"]}>
            <div className={classes["table-button"]}>
              <img
                src={TableIcon}
                className={classes["table-icon"]}
                alt="Table Icon"
              />
            </div>
          </div>
          <div className={classes["right-side"]}>
            <div className={classes["button-margin"]}>
              <Button
                variant="info"
                size="sm"
                className={classes["text-button"]}
              >
                + New Test
              </Button>
            </div>
            <div className={classes["button-margin"]}>
              <Button
                variant="dark"
                size="sm"
                className={classes["text-button"]}
              >
                + Express Approve/Reject
              </Button>
            </div>
            <div className={classes["button-small-margin"]}>
              <Button
                variant="success"
                size="sm"
                className={classes["text-button"]}
              >
                + Export
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OverviewPage;
